import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { FieldOption } from '../../../../../../admin-portal/admin/models/safr-type';

@Component({
    selector: 'wre-field-options-table',
    templateUrl: './field-options-table.component.html',
    styleUrls: ['./field-options-table.component.sass'],
    standalone: false
})
export class FieldOptionsTableComponent {

  @Input() control: UntypedFormControl;

  offset = '0';
  get options(): FieldOption[] {
    const list = !!this.control ? this.control.value : [];
    return list;
  }
}
